import { render, staticRenderFns } from "./DashboardQuickMenu.vue?vue&type=template&id=2bf26c78&scoped=true"
import script from "./DashboardQuickMenu.vue?vue&type=script&lang=js"
export * from "./DashboardQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuickMenu.vue?vue&type=style&index=0&id=2bf26c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf26c78",
  null
  
)

export default component.exports